import { GridFilterModel } from "@mui/x-data-grid";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface TableState {
  filters: GridFilterModel;
  columns: string[];
  sort: any;
  global_search:any;
  expiry:number;
}

interface TableStateMap {
  [tableName: string]: TableState;
}

const initialState: TableStateMap = {
   
  defaultTable: {
    filters: {
      items: [],
      quickFilterValues: [],
    },
    columns: [],
    sort: [],
    global_search:"",
    expiry: 0,
  },
};

const tableSlice = createSlice({
  name: "table",
  initialState,
  reducers: {
    setTableState: (
      state,
      action: PayloadAction<{
        tableName: string;
        state: TableState;
        storageKey?: string;
      }>
    ) => {
      if( action.payload.state.expiry>0 && (new Date().getTime() >= action.payload.state.expiry) ){
        delete state[action.payload.tableName];
        localStorage.removeItem(
          action.payload.storageKey ?? action.payload.tableName
        );
        return
      }
      state[action.payload.tableName] = action.payload.state;
      localStorage.setItem(
        action.payload.storageKey ?? action.payload.tableName,
        JSON.stringify(action.payload.state)
      );
    },
    removeTableState: (
      state,
      action: PayloadAction<string | { tableName: string; storageKey?: string }>
    ) => {
      const tableName =
        typeof action.payload === "string"
          ? action.payload
          : action.payload.tableName;
      const storageKey =
        typeof action.payload === "string"
          ? action.payload
          : action.payload.storageKey ?? action.payload.tableName;

      delete state[tableName];
      localStorage.removeItem(storageKey);
    },
  },
});

export const { setTableState, removeTableState } = tableSlice.actions;
export default tableSlice.reducer;
